<template>
  <div class="user-location-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置表格列 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_user_location.xiang_mu_ming_cheng')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :height="vheight" :index="true" tableCode="user_location" :data="tableList" @column="setColumn" @filter="filterChange" @sort="sortChange"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  mixins: [resetFormSearchMixins],
  props: {
    vheight: {
      type: String,
    },
    userId: {
      type: [String, Number, Boolean],
      default: '',
    },
  },
  data() {
    return {
      formSearch: {
        userId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      tableSelect: [],
      dialogVisible: false,
      dialogModel: {},
    };
  },
  watch: {
    userId: function () {
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getLocationPage();
    },
  },
  mounted: function () {
    this.getFuncView('/company/user');
    this.getLocationPage();
  },
  methods: {
    onSuccess() {
      this.$emit('success');
      this.getLocationPage();
    },
    // 获取项目分页
    getLocationPage: function () {
      if (!this.userId) {
        this.tableList = [];
        this.totalRows = 0;
        return;
      }
      this.formSearch.userId = this.userId;
      this.$getJSON(apis.deviceUserLocation, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationPage();
    },
  },
};
</script>

<style lang="scss"></style>
